const controls = state => state.controls;
const control = state => state.control;
const controller_status = state => state.controller_status;

export {
    controls,
    control,
    controller_status
}
